import "swiper/swiper-bundle.css";

import { Autoplay, EffectFade } from "swiper/modules";

import Swiper from "swiper";
import simpleParallax from "simple-parallax-js";

Array.from(
	document.querySelectorAll(".hero-carousel[data-home='false'] .swiper")
).map((hero) => {
	const swiper = new Swiper(hero, {
		modules: [EffectFade, Autoplay],
		autoplay: {
			delay: 7500,
		},
		effect: "fade",
		loop: true,
	});

	var images = hero.querySelectorAll("img");
	new simpleParallax(images, {
		scale: 1.2,
	});
});
